import { API_PREFIX } from "./api.constants";

const base = (courseId: number | string) =>
  `${API_PREFIX}/courses/${courseId}/ojt-activities`;

/** OJT (On-the-Job Training) activity endpoints. */
export const OJT_ENDPOINTS = {
  // Config
  OJT: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}`,

  // Tasks
  TASKS: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}/tasks`,
  TASK: (courseId: number | string, taskId: number | string) =>
    `${base(courseId)}/tasks/${taskId}`,

  // Scales / rubrics
  SCALES: (courseId: number | string) => `${base(courseId)}/scales/list`,
  SCALE_CREATE: (courseId: number | string) => `${base(courseId)}/scales`,
  SCALE: (courseId: number | string, scaleId: number | string) =>
    `${base(courseId)}/scales/${scaleId}`,

  // Submissions + report
  SUBMISSIONS: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}/submissions`,
  REPORT: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}/report`,
  SUBMISSION: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}`,
  SME: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/sme`,
  MANAGER: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/manager`,
  GRADE: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/grade`,
  REOPEN: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/reopen`,
  SUPERVISORS: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}/supervisors`,
  SUPERVISOR_CANDIDATES: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}/supervisor-candidates`,
  RETURN: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/return`,

  // Learner / participant
  MY: (courseId: number | string, activityId: number | string) =>
    `${base(courseId)}/${activityId}/my`,
  SUBMISSION_VIEW: (courseId: number | string, activityId: number | string, submissionId: number | string) =>
    `${base(courseId)}/${activityId}/submission/${submissionId}/view`,
  LEARNER: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/learner`,
  ATTACHMENT: (courseId: number | string, submissionId: number | string) =>
    `${base(courseId)}/submission/${submissionId}/attachment`,
  ATTACHMENT_DELETE: (courseId: number | string, attachmentId: number | string) =>
    `${base(courseId)}/attachment/${attachmentId}`,
};

/** Site-level (tenant-wide) reusable OJT rubric/scale admin endpoints. */
export const OJT_SCALE_ADMIN_ENDPOINTS = {
  LIST: `${API_PREFIX}/ojt-scales`,
  CREATE: `${API_PREFIX}/ojt-scales`,
  ONE: (scaleId: number | string) => `${API_PREFIX}/ojt-scales/${scaleId}`,
};

/** SME cross-course evaluation inbox. */
export const OJT_EVALUATIONS_ENDPOINTS = {
  QUEUE: `${API_PREFIX}/ojt-evaluations/queue`,
  RECORDS: `${API_PREFIX}/ojt-evaluations/records`,
  AM_EVALUATOR: `${API_PREFIX}/ojt-evaluations/am-evaluator`,
};
